<template>
  <v-container>
    <v-card title="Purchased Products">
      <v-card-text>
        <v-data-table-server
          v-model:items-per-page="pagination.limit"
          :items="teams"
          :headers="headersTeam"
          :items-length="count"
          :loading="loading"
          :search="pagination.q"
          item-key="id"
          @update:options="handleLimitChange">
          <template v-slot:[`item.name`]="{ item }">
            <router-link
              :to="{ name: 'AdminYearTeamDetailView', params: { yearId, teamId: item.id } }"
              >{{ item.name }}</router-link
            >
          </template>
          <template v-slot:[`item.productDescription`]="{ item }">
            <span v-html="item.teamCriteria[0].order?.productVariant?.description"> </span>
          </template>
          <template v-slot:top>
            <v-text-field
              v-model="pagination.q"
              class="ma-2"
              density="compact"
              placeholder="Search team..."
              hide-details></v-text-field>
            <v-btn color="primary" @click="exportToCSV(headersTeam, teams)">Export to CSV</v-btn>
          </template>
        </v-data-table-server>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import type { VDataTableServer } from 'vuetify/components';
import { useTeamStore } from '@/stores/index';
import { IHeaderDTO, IPaginationDTO, PaginationDTO } from '@/dtos';
import { SNACKSTATUS } from '@/stores/util';
import { exportToCSV } from '@/helpers';

const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
interface Props {
  branchId: string;
  yearId: string;
}
const props = defineProps<Props>();
const branchId = computed(() => props.branchId);
const yearId = computed(() => props.yearId);
const teamStore = useTeamStore();
const pagination = ref<IPaginationDTO>(new PaginationDTO());
const query = teamStore.getTeamsForYearWithCheckin(branchId, yearId, pagination);
const loading = computed(() => query.isLoading.value);
const teams = computed(() => query.data.value?.data ?? []);
const count = computed(() => query.data.value?.count ?? 0);

const headersTeam = [
  { title: 'Name', key: 'name', align: 'start', sortable: true },
  {
    title: 'Product',
    key: 'productDescription',
    sortable: false,
    field: 'teamCriteria[0].order.productVariant.description',
  },
  { title: '', key: 'action', sortable: false },
] as IHeaderDTO[];

const handleLimitChange = (value: VDataTableServer) => {
  pagination.value.buildPagination(value);
};
</script>
